import type { SafeOmit } from '@/core/types/safe-omit';
import type { PageComponentProps } from '@/features/a-dynamic-page/components/page-component-switch';
import type { SeasonCalendarType } from '@/features/season-calendar/season-calendar-type';

import SeasonCalendar from '@/features/season-calendar/season-calendar';

type ConfigProps = {
    rowCount?: 1 | 2 | 3;
};

export type SeasonCalendarV2Props = SafeOmit<
    PageComponentProps<SeasonCalendarType, Object, ConfigProps>,
    'componentId' | 'componentIri' | 'componentType' | 'pageComponentIndex'
>;

export default function SeasonCalendarV2({ attributes, configProps = { rowCount: 2 } }: SeasonCalendarV2Props) {
    return (
        <SeasonCalendar
            rowCount={configProps?.rowCount}
            seasonCalendar={attributes.seasonCalendar}
            title={attributes.title}
            titleFontSize={'font-size-16'}
        />
    );
}
